import { ProjectModel } from 'api/dto/Project.dto';
import { PulseTemplateModel } from 'api/dto/PulseTemplate.dto';

export const getProject = (projectOrTemplate: ProjectModel | PulseTemplateModel): ProjectModel => {
  return PulseTemplateModel.isPulseTemplateModel(projectOrTemplate)
    ? projectOrTemplate.project
    : projectOrTemplate;
};
